import React from 'react';
import { formatDate } from './formatDate';
import { translateMessagingStatus } from './messagingStatusParse';

const parseOccurredAt = (row) => {
  const value = row?.occurredAt || row?.createdAt;
  const date = value ? new Date(value) : new Date(0);
  return Number.isNaN(date.getTime()) ? 0 : date.getTime();
};

const sortByOccurredAt = (a, b) => {
  const timeDiff = parseOccurredAt(a) - parseOccurredAt(b);
  if (timeDiff !== 0) return timeDiff;

  const whatsappDiff = String(a.whatsappId || '').localeCompare(String(b.whatsappId || ''));
  if (whatsappDiff !== 0) return whatsappDiff;

  return String(a.id || '').localeCompare(String(b.id || ''));
};

const mapMessagingHistoryToEvents = (rows = []) => {
  const byDispatch = new Map();

  rows.forEach((row) => {
    const key = row.whatsappId || row.id;
    if (!byDispatch.has(key)) {
      byDispatch.set(key, []);
    }
    byDispatch.get(key).push(row);
  });

  const events = [];

  byDispatch.forEach((group) => {
    group.sort(sortByOccurredAt);

    group.forEach((row, index) => {
      const oldStatus = index === 0 ? null : group[index - 1].status;
      const newStatus = row.status;

      events.push({
        date: formatDate(row.occurredAt || row.createdAt),
        operator: 'Sistema',
        label: 'Alteração de status de mensageria',
        description: (
          <>
            Status Origem: {translateMessagingStatus(oldStatus)} - Status Destino:{' '}
            <strong>{translateMessagingStatus(newStatus)}</strong>
          </>
        ),
        oldStatus,
        newStatus,
        sortKey: parseOccurredAt(row),
      });
    });
  });

  return events
    .sort((a, b) => a.sortKey - b.sortKey)
    .map(({ sortKey, ...event }) => event);
};

export default mapMessagingHistoryToEvents;
